// validation rules

const emailRuleRegEx = /([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?\;?\,?)$/ig;
const requiredRuleRegEx = '^(?!\\s*$).+';
const phoneRuleRegEx = /[0-9]{3}(\-)[0-9]{3}(\-)[0-9]{4}/;
const dateRuleRegEx = /[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}/;

const emailRule = {
  regEx: emailRuleRegEx,
  message: 'Please provide a valid Email.',
};

const requiredRule = {
  regEx: requiredRuleRegEx,
  message: 'This field is required',
};

const phoneRule = {
  regEx: phoneRuleRegEx,
  message: 'Please enter valid phone number',
};

const dateRule = {
  regEx: dateRuleRegEx,
  message: 'Please enter a valid date',
};

export {
  emailRule,
  requiredRule,
  phoneRule,
  dateRule,
  emailRuleRegEx,
  dateRuleRegEx,
  phoneRuleRegEx,
  requiredRuleRegEx,
};
